import { useState } from 'react'
import { NewAssetSubStep } from './NewAssetSubStep'
import { AssetStepProps, ExistingAssetSubStep } from './ExistingAssetSubStep'
import { FormControlLabel, Radio, RadioGroup, styled } from '@mui/material'
import { contentSpacing, PageGridItem } from 'ComponentLibrary'
import { useTranslation } from 'react-i18next'

export function AssetStep({ assetsData, order, ...props }: AssetStepProps) {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.createOrderPage.asset' })
    const [isExistingAsset, setIsExistingAsset] = useState<boolean>(!!order.asset_uuid)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsExistingAsset(event.target.value === 'true')
    }

    return (
        <>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <RadioGroup
                    value={isExistingAsset}
                    onChange={handleChange}
                    sx={{ gap: `${contentSpacing}px`, marginBottom: `${contentSpacing}px`, maxWidth: '360px' }}
                >
                    <FormControlLabel label={t('createNew')} value={false} control={<StyledRadio />} />
                    <FormControlLabel label={t('linkExisting')} value={true} control={<StyledRadio />} />
                </RadioGroup>
            </PageGridItem>
            {!isExistingAsset ? (
                <NewAssetSubStep order={order} {...props} />
            ) : (
                <ExistingAssetSubStep order={order} {...props} assetsData={assetsData} />
            )}
        </>
    )
}

const StyledRadio = styled(Radio)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&.Mui-checked': {
        color: theme.palette.secondary.main,
    },
    paddingTop: 0,
    paddingBottom: 0,
}))
